import * as types from "./camposDinamicos.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  arrayCaracteristicas: [],
  changeState: new Date().getTime(),
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload;

  switch (action.type) {
    case types.SET_CAMPOS_DINAMICOS:
      return state.merge({ arrayCaracteristicas: payload });
    case types.RESETFORM:
      return state.merge({
        arrayCaracteristicas: state.arrayCaracteristicas.map(pai => {
          return {
            ...pai,
            CaracteristicasFilhas: pai.CaracteristicasFilhas.map(filha => {
              return {
                ...filha,
                Valor: { Exibicao: '' },
              };
            }),
          };
        }),
        changeState: new Date().getTime(),
      });
    case commonActionType.RESET:
      return initialState.merge({ ...state });
    default:
      return state;
  }
};

store.registerDynamicModule("camposDinamicos", reduce);
